import DataTable from 'components/ui/DataTable/data-table';
import React, { FC, useState } from 'react';
import { IEvaluationFormInuput } from 'redux/reducers/evaluationCriteria';
import { useListEvaluationCriteriaQuery } from 'redux/reducers/evaluationCriteria';
import ViewIcon from '../../../assets/images/icons/view.png';
import EditIcon from '../../../assets/images/icons/edit.png';
import DeleteIcon from '../../../assets/images/icons/delete.png';
import 'css/style.css';
interface ITraineeDataTable {
  searchQuery: string;
  onEditClicked: (data: IEvaluationFormInuput) => void;
  onDeleteClicked: (data: IEvaluationFormInuput) => void;
  onViewClicked: (data: IEvaluationFormInuput) => void;
}
const EvaluationCriteriaTable: FC<ITraineeDataTable> = ({
  searchQuery,
  onEditClicked,
  onDeleteClicked,
  onViewClicked
}) => {

  const [pageNo, setPage] = useState(1);
  const pageSize=10
  const { data: routineData, isLoading, isSuccess, isFetching } = useListEvaluationCriteriaQuery(    {

    searchQuery,
    pageNo,
    pageSize,
  });
  const [allDataList, setAllDataList] = useState(0);
  const totalRows = routineData?.data && routineData?.data.length > 0 ? routineData?.data?.[0].row_total : 0;

  const totalPages = Math.ceil(totalRows / 10);
  const canNext = pageNo < totalPages;
  const canPrevious = pageNo > 1;

 
  const columns: any = [
    {
      Header: 'Criteria Name',
      accessor: 'name'
    },
    {
      Header: ' Sub Criteria',
      accessor: 'Parents',
      Cell: (data: any) => {
        return <>{data.row.original?.parent_detail?.name}</>;
      }
    },

    {
      Header: 'Code',
      accessor: 'code'
    },

    {
      Header: '  Action',
      Cell: (data: any) => {
        return (
          <>
            <img
              src={EditIcon}
              className="icons"
              onClick={() =>
                onEditClicked({
                  ...data.row.original,
                  parent: data.row.original.parent_detail?.parent_id || null
                })
              }
            />
            <img
              src={DeleteIcon}
              className="m-2 icons"
              onClick={() => onDeleteClicked(data.row.original)}
            />
            <img
              src={ViewIcon}
              className="icons"
              onClick={() => onViewClicked(data.row.original)}
            />
          </>
        );
      }
    }
  ];
  return (
    <div className="list form-check-all">
      <DataTable
        columns={columns}
        isLoading={isFetching}
        search={false}
        data={routineData?.data || []}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => {
           if (canPrevious) {
              setPage((prev) => prev - 1);

            }
          },
          nextPage: () => {
            if (canNext) {
              setPage((prev) => prev + 1);
            }
          }
        }}
      />
    </div>
  );
};

export default EvaluationCriteriaTable;
